import React, { useState, useEffect, useRef } from 'react';
import { Editor } from "react-draft-wysiwyg";
import {
    EditorState, ContentState, convertToRaw, AtomicBlockUtils
} from "draft-js";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import createImagePlugin from '@draft-js-plugins/image';
import '../../assets/css/RichTextEditor.css';
import '@draft-js-plugins/image/lib/plugin.css';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const imagePlugin = createImagePlugin();
export default function RichTextEditor({ name, value, onChange, invalid, disabled, ref }) {
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const editorRef = useRef(null);

    const onEditorStateChange = (change) => {
        if (!disabled) {
            const editorHTML = draftToHtml(convertToRaw(change.getCurrentContent()));
            const e = { target: { name: name, value: editorHTML } }
            onChange(e);
            setEditorState(change);
        }
    };

    const loadData = (content) => {
        const contentState = editorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity('separator', 'IMMUTABLE', {});
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        const contentBlock = htmlToDraft(content);
        if (contentBlock) {
            const { contentBlocks, entityMap } = contentBlock;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const editorStateValue = EditorState.createWithContent(contentState);
            const contentStateWithKey = AtomicBlockUtils.insertAtomicBlock(
                editorStateValue,
                entityKey,
                ' '
            );
            setEditorState(contentStateWithKey);
        }

    }

    useEffect(() => {
        loadData(value);
        editorRef.current = true;
        return () => { editorRef.current = false };
    }, []);
    return (
        <>
            {editorState
                ?
                <Editor
                    editorState={editorState}
                    wrapperClassName="demo-wrapper"
                    editorClassName={`demo-editor ${invalid ? "invalid" : ""}`}
                    plugins={[imagePlugin]}
                    onEditorStateChange={onEditorStateChange}
                />
                : <></>
            }
        </>
    );
}